import ProductInfoSec from "./ProductInfoSec";

export default ProductInfoSec;
